import axios from "axios";
import store from "@/store";

const http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  headers: {
    "Content-Type": "application/json"
  }
});
http.interceptors.request.use(
  function(config) {
    store.dispatch("setLoading", true);
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      config.headers["Authorization"] = `Bearer ${user.token}`;
    }
    return config;
  },
  function(error) {
      return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function(response) {
    store.dispatch("setLoading", false);
    return response;
  },
  function(error) {
    store.dispatch("setLoading", false);
    if (
        error.response.status === 401 ||
        error.response.status === 403
    ) {
      store.dispatch("logout");
    }
    store.dispatch("setSnackBar", {
        text: error.response.data.message,
        type: 'error'
    });
    return Promise.reject(error);
  }
);

export default http;
